import { msalInstance } from "../msalConfig";
import { config } from "../config";

export async function getAuthApiToken() {
  const accounts = msalInstance.getAllAccounts();
  
  if (!accounts || accounts.length === 0) {
    throw new Error("No user logged in. Please login first.");
  }
  
  const currentAccount = msalInstance.getAllAccounts()[0];
  const request = {
    account: currentAccount,
    scopes: [`api://${config.authClientId}/access_as_user`]
  };
  
  try {
    const response = await msalInstance.acquireTokenSilent(request);
    return response.accessToken;
  } catch (error) {
    console.log("Silent token acquisition failed, trying popup...");
    try {
      const response = await msalInstance.acquireTokenPopup(request);
      console.log("Token acquired via popup");
      return response.accessToken;
    } catch (popupError) {
      console.error("Token acquisition failed");
      throw new Error("Failed to get API token");
    }
  }
}

export async function getIncidentApiToken(account) {
  // If account is provided, use it directly
  if (account) {
    const request = {
      account: account,
      scopes: [`api://${config.incidentClientId}/access_as_user`]
    };
    
    try {
      const response = await msalInstance.acquireTokenSilent(request);
      return response.accessToken;
    } catch (error) {
      console.log("Silent token acquisition failed, trying popup...");
      try {
        const response = await msalInstance.acquireTokenPopup(request);
        console.log("Token acquired via popup");
        return response.accessToken;
      } catch (popupError) {
        console.error("Token acquisition failed");
        throw new Error("Failed to get API token");
      }
    }
  }
  
  // If no account provided, try to get from stored accounts
  const accounts = msalInstance.getAllAccounts();
  
  if (!accounts || accounts.length === 0) {
    throw new Error("No user logged in. Please login first.");
  }
  
  const request = {
    account: accounts[0],
    scopes: [`api://${config.incidentClientId}/access_as_user`]
  };
  
  try {
    const response = await msalInstance.acquireTokenSilent(request);
    return response.accessToken;
  } catch (error) {
    console.log("Silent token acquisition failed, trying popup...");
    try {
      const response = await msalInstance.acquireTokenPopup(request);
      console.log("Token acquired via popup");
      return response.accessToken;
    } catch (popupError) {
      console.error("Token acquisition failed");
      throw new Error("Failed to get API token");
    }
  }
}